import React, { useEffect, useState, useRef } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { PrimaryButton } from '../../components/Buttons';
import { Dialog, DialogContent, DialogTitle } from '@mui/material'; // Import Dialog components
import axiosInstance from "../../services/api/axios";
import { assignAgentsToConfigs } from '../../services/users';


const AssignAgentComponent = ({ projectId, selectedConfig, configId, isOpen, onClose }) => {
    const [selectedAgent, setSelectedAgent] = useState(null);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [assignedAgentsInfo, setAssignedAgentsInfo] = useState([]);
    const [agentInfo, setAgentInfo] = useState('');
    const [noAgentsMessage, setNoAgentsMessage] = useState('');
    const [setIsOpen] = useState(isOpen); // Internal modal state
    const [agents, setAgents] = useState([]);//all the agents
    const [assignedAgents, setassignedAgents] = useState([]);//all agents that are assigned
    const [loading, setLoading] = useState(false)

    const dropdownRef = useRef(null);  // Create a ref for the dropdown container


    const toggleDropdown = () => {
        setIsDropdownOpen((prev) => !prev);
    };
    const fetchAgents = async (configId) => {
        try {
            setLoading(true)
            const allAgentsResponse = await axiosInstance.get(
                `customers/relation?projectId=${projectId}`
            );
            setAgents(allAgentsResponse);
            if (configId) {
                const selectAgentsResponse = await axiosInstance.get(
                    `customers/property/config?propertyConfigId=${configId}`
                );
                setassignedAgents(selectAgentsResponse);
            }
        } catch (error) {
            console.error("Error fetching media images:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (agents && agents.length === 0) {
            setNoAgentsMessage("No Agents Available");
            setAssignedAgentsInfo([]);
            setAgentInfo('');
            return;
        }

        if (assignedAgents) {
            const matchedAgents = agents.filter((agent) =>
                assignedAgents.some((assigned) => assigned.customerId === agent.secondaryCustomer?.customerId)
            );

            setAssignedAgentsInfo(matchedAgents.map(agent => ({
                name: agent.secondaryCustomer?.ownerName,
                email: agent.secondaryCustomer?.emailId,
                phone: agent.secondaryCustomer?.mobileNoWa,
            })));

            if (matchedAgents.length > 0) {
                setAgentInfo("Select an agent");
                setNoAgentsMessage("");
            } else {
                setNoAgentsMessage("No agents Assigned Yet");
                setAgentInfo('');
            }


        } else if (agents && agents.length > 0) {
            setNoAgentsMessage("");
            setAgentInfo('');

        }
        else {
            setNoAgentsMessage("No Agents Available");
            setAssignedAgentsInfo([]);
            setAgentInfo('');

        }
    }, [assignedAgents, agents]);

    useEffect(() => {
        setLoading(true)
        if (configId) {
            fetchAgents(configId)
        } else {
            fetchAgents()
        }
        setLoading(false)
    }, [configId, isOpen])

    const handleAgentSelection = (agent) => {
        if (agent.secondaryCustomer) {
            setSelectedAgent(agent);
            setAgentInfo(agent.secondaryCustomer.ownerName);
        }
        setIsDropdownOpen(false);  
    };

    const handleAssignAgent = async (selectedAgent) => {
        const payload = selectedAgent.map((agent) => ({
            customerId: agent.secondaryCustomer.customerId,
            propertyConfigId: selectedConfig.propertyConfigId,
            isPrimary: false,
        }));
        if (selectedAgent && selectedConfig.propertyConfigId) {
            try {
                await assignAgentsToConfigs(payload);
                await fetchAgents(selectedConfig.propertyConfigId);
            } catch (error) {
                console.error("Error assigning agent:", error);
            }
        }

    };

    const handleAssign = (e) => {
        e.stopPropagation();
        if (selectedAgent) {
            const isAlreadyAssigned = assignedAgents && assignedAgents.some(
                (assigned) => assigned.customerId === selectedAgent.secondaryCustomer.customerId
            );
            if (!isAlreadyAssigned) {
                handleAssignAgent([selectedAgent]);
                setAssignedAgentsInfo((prev) => [
                    ...prev,
                    {
                        name: selectedAgent.secondaryCustomer.ownerName,
                        email: selectedAgent.secondaryCustomer.emailId,
                        phone: selectedAgent.secondaryCustomer.mobileNoWa,
                    },
                ]);
                toast.success(`Agent ${selectedAgent.secondaryCustomer.ownerName} assigned successfully!`);
            }
            setSelectedAgent(null);
            setAgentInfo("Select An agent");
            setIsDropdownOpen(false);
            closeModal();
        }
    };

    // NEW: Close dropdown on outside click
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [dropdownRef]);

    // Function to open the modal
    const closeModal = () => {
        setIsOpen(false);
        onClose();  // Call the onClose handler passed from ProjectDetailsContent
    };


    return (
        <>
          <Dialog open={isOpen} onClose={closeModal} fullWidth maxWidth="md"> {/* Adjust maxWidth as needed */}
       <div>Assign Channel Partner</div> {/* Add a title */}
       <DialogContent>
       {loading ? (
         <> Loading </>
       ) : (
           <div className="md:p-4 p-4" ref={dropdownRef}>
             {/* Attach ref */}
             <h2 className="text-xl mb-4 font-semibold text-black">
               Assign Channel Partner
             </h2>

             <div className="mt-4 flex items-center space-x-4">
               <div className="relative w-full">
                 <div
                   className="border border-gray-300 p-2 rounded cursor-pointer"
                   onClick={toggleDropdown}
                 >
                   <span>{agentInfo ? agentInfo : "Select "}</span>
                 </div>
                 {isDropdownOpen && (
                   <div className="absolute w-full mt-2 bg-white border border-gray-300 rounded shadow-lg z-10 max-h-40 overflow-y-auto">
                     {agents && agents.length > 0 ? (
                       agents.map((agent) =>
                         agent.secondaryCustomer ? (
                           <div
                             key={agent.secondaryCustomer.customerId}
                             className="flex flex-col p-2 hover:bg-gray-100 cursor-pointer"
                             onClick={() => handleAgentSelection(agent)}
                           >
                             <span className="text-md font-medium">
                               {agent.secondaryCustomer.ownerName}
                             </span>
                             <span className="text-xs">
                               {agent.secondaryCustomer.emailId} {" | "}
                               {agent.secondaryCustomer.mobileNoWa}
                             </span>
                           </div>
                         ) : null
                       )
                     ) : (
                       <div className="p-2 text-center text-gray-500">
                         {noAgentsMessage}
                       </div>
                     )}
                   </div>
                 )}
               </div>

               <PrimaryButton
                 className={"w-32, h-10"}
                 onClick={(e) => {
                   handleAssign(e);
                 }}
                 disabled={!selectedAgent}
               >
                 Assign
               </PrimaryButton>
             </div>

             {/* Display the assigned agents in cards */}
             {assignedAgentsInfo.length > 0 && (
               <div className="mt-6 space-y-4  ">
                 {assignedAgentsInfo.map((agent, index) => (
                   <div
                     key={index}
                     className="flex flex-col p-2  cursor-pointer border rounded-md p-4"
                   >
                     <span className="text-lg font-medium">{agent.name}</span>
                     <span className="text-sm font-normal">
                       {agent.email} | {agent.phone}
                     </span>
                   </div>
                 ))}
               </div>
             )}
           </div>
       )}
       </DialogContent>
     </Dialog>
      </>
      );
};

export default AssignAgentComponent;